import { generatePath, NavLink, useParams } from 'react-router-dom';
import { useAppSelector } from '@store';
import {
  IconArrowRight,
  IconChangeLoClock,
  IconCloseCircle,
  IconLock,
  PermissionEnum,
} from '@ui/src';
import { CustomerStatus, OrganizationType } from '../../../common/types';

import ROUTES from '../../../../routes';

import commonStyles from '../../../common/common.module.css';
import cn from '../styles.module.css';

const OverviewTopContent = ({
  setChangeLogPanelIsOpen,
  setReopenPopupVisible,
}: {
  setChangeLogPanelIsOpen: (data: boolean) => void;
  setReopenPopupVisible: (data: boolean) => void;
}) => {
  const { customerId } = useParams();

  const { baseUserInformation } = useAppSelector(
    (state) => state.individualCustomers.info.overview,
  );
  const { activePermissions } = useAppSelector((state) => state.root);
  const { baseInformation, activeLock } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );

  let applicationLink = generatePath(
    ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO,
    { applicationId: baseInformation?.applicationId || '' },
  );

  if (baseInformation?.type === OrganizationType.COMPANY_OFFICIAL) {
    applicationLink = generatePath(
      ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL,
      { applicationId: baseInformation?.applicationId || '' },
    );
  }

  return (
    <>
      <div
        className={`${commonStyles.overviewTitleWrapper} ${
          !baseUserInformation?.fullName ? commonStyles.flexEnd : ''
        }`}
      >
        {baseUserInformation?.fullName && (
          <div className={commonStyles.overviewTitle}>
            {baseUserInformation.fullName}
          </div>
        )}
        <div className={commonStyles.overviewTopRight}>
          {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <button
              type="button"
              className={commonStyles.applicationLink}
              onClick={() => setChangeLogPanelIsOpen(true)}
            >
              <IconChangeLoClock />
              Change Log
            </button>
          )}

          {baseInformation?.applicationId && (
            <NavLink
              to={applicationLink}
              className={commonStyles.applicationLink}
              target="_blank"
            >
              Go to application
            </NavLink>
          )}
        </div>
      </div>
      {baseInformation?.status === CustomerStatus.CLOSED && (
        <div className={commonStyles.closedContent}>
          <div className={commonStyles.closeContentLeft}>
            <div className={commonStyles.closeContentLeftTitle}>
              <IconCloseCircle width={24} height={24} />
              Organization is closed
            </div>
            <div className={commonStyles.closeContentLeftDescription}>
              {baseInformation?.statusChangeReason}
            </div>
          </div>
          {activePermissions?.includes(
            PermissionEnum.INDIVIDUAL_CUSTOMERS_OPEN_ACTION,
          ) && (
            <div className={commonStyles.closeContentRight}>
              <button
                type="button"
                className={commonStyles.reopenButton}
                onClick={() => setReopenPopupVisible(true)}
              >
                Reopen
              </button>
            </div>
          )}
        </div>
      )}
      {activeLock && (
        <div
          className={`${cn.lockInfo} ${
            baseInformation?.status === CustomerStatus.CLOSED
              ? cn.withMarginTop
              : ''
          }`}
        >
          <div className={cn.lockInfoLeft}>
            <div className={cn.lockInfoIcon}>
              <IconLock />
            </div>
            <div className={cn.lockInfoText}>Authorization is locked</div>
          </div>
          <div className={cn.lockInfoLinkWrapper}>
            <NavLink
              to={`${generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS, {
                customerId: (customerId as string) || '',
              })}?locked=true`}
              className={cn.lockInfoLink}
            >
              <div className={cn.lockInfoLinkContent}>View locks</div>
              <div className={cn.lockInfoLinkContent}>
                <IconArrowRight />
              </div>
            </NavLink>
          </div>
        </div>
      )}
    </>
  );
};

export default OverviewTopContent;
